<template>
    <div>
        <loyalty-points-delete-dialog
            v-if="isEditMode"
            :resource="loyaltyPointsResource"
            :resource-id="resourceId"
            :child-dependencies-warning="false"
        />
        <delete-button v-else background @delete="cancelCreation" />
    </div>
</template>

<script>
import resources from '@enums/resources';
import { isFunction } from 'lodash';

export default {
    data() {
        return {
            loyaltyPointsResource: resources.loyaltyPoints,
        };
    },
    computed: {
        resourceId() {
            return this.params.data._id;
        },
        isEditMode() {
            return this.resourceId;
        },
    },
    methods: {
        cancelCreation() {
            const selectedNode = this.params.node;
            const selectedData = selectedNode.data;
            this.params.api.applyTransaction({ remove: [selectedData] });

            if (isFunction(this.params.onCancelCreation)) {
                this.params.onCancelCreation();
            }
        },
    },
};
</script>
